import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import MistryBhaiApp from "../app/page";
import "../app/globals.css";
import { startAnalytics } from "../app/firebase";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MistryBhaiApp />
  </StrictMode>,
);

void startAnalytics();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
